import { PolygraphyProductFormat } from '../../../../../services/exports/Constants';

export default {
  form: {
    name: {
      label: 'Geef deze printopdracht een naam',
      placeholder: 'A5 flyer - speciale aanbieding',
    },
    format: {
      label: 'Producttype',
      placeholder: 'Selecteer producttype',
      options: {
        [PolygraphyProductFormat.FlyerA5]: 'Flyer (A5)',
        [PolygraphyProductFormat.FlyerA6]: 'Flyer (A6)',
        [PolygraphyProductFormat.Sticker60x60]: 'Sticker (60x60mm)',
        [PolygraphyProductFormat.DoorStickerA5]: 'Deursticker (30x30cm)',
      },
    },
    file: {
      label: 'Bestand',
    },
  },
  buttons: {
    upload: 'Klik of sleep om bestand te uploaden',
    save: 'Opslaan',
  },
  toasts: {
    changes_got_saved: 'Wijzigingen opgeslagen!',
  },
};
